"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var splide_1 = __importDefault(require("@splidejs/splide"));
var Quotes = /** @class */ (function (_super) {
    __extends(Quotes, _super);
    function Quotes() {
        var _this = this;
        var _a;
        _this = _super.call(this, constants_1.DATA_QUOTES) || this;
        if (!_this.getElement())
            return _this;
        _this.quoteEls = document.querySelectorAll("[".concat(constants_1.DATA_QUOTES, "]"));
        if (!(_this.quoteEls && _this.quoteEls.length > 0))
            return _this;
        var splideOptions = {
            type: 'fade',
            perPage: 1,
            pagination: false,
            snap: true,
            speed: 750,
        };
        (_a = _this.quoteEls) === null || _a === void 0 ? void 0 : _a.forEach(function (quoteEl) {
            var quoteSlider = quoteEl.querySelector("[".concat(constants_1.DATA_QUOTES_SLIDER, "]"));
            if (!quoteSlider)
                return;
            var quotesSplide = new splide_1.default(quoteSlider, splideOptions);
            quotesSplide.mount();
        });
        return _this;
    }
    return Quotes;
}(AbstractComponent_1.default));
exports.default = Quotes;
